<div class="further-qualification-start-widget-container">
  <span class="content-further-qualification">{{
    'platformWidget.furtherQualification.start.description' | transloco
  }}</span>
  <a class="link-further-qualification" [routerLink]="['/enable-organization']">
    {{ 'platformWidget.furtherQualification.start.link' | transloco }}
    <markant-icon icon="m_arrow-right"></markant-icon>
  </a>
</div>
